import React from "react";
import "./arrow-back-button.scss";
import backArrowSrc from "./back-arrow.svg";
import SVG from "react-inlinesvg";

const ArrowBackButton = ({ className = "", onClick, children, ...rest }) => {
  return (
    <button
      className={`ArrowBackButton ${className}`}
      onClick={onClick}
      {...rest}
    >
      <SVG src={backArrowSrc} alt="" /> {children || "Back"}
    </button>
  );
};

export default ArrowBackButton;
